import { colors, spacing, typography } from '@mehilainen/mds-tokens';
import { badgeClasses, buttonClasses, } from '@mui/material';
const badgeTopRightCircular = `.${badgeClasses.badge}.${badgeClasses.anchorOriginTopRight}.${badgeClasses.overlapCircular}`;
export const getThemeBadge = (_tokens) => ({
    MuiBadge: {
        styleOverrides: {
            root: {
                // if badge is on rounded button on top right corner
                [`&:has(> button.${buttonClasses.root})`]: {
                    alignSelf: 'start',
                    [`&:has(> button.${buttonClasses.sizeSmall}) > ${badgeTopRightCircular}`]: {
                        right: spacing[200].px,
                        top: 0,
                    },
                    [`&:has(> button.${buttonClasses.sizeMedium}) > ${badgeTopRightCircular}`]: {
                        right: spacing[250].px,
                        top: 0,
                    },
                    [`&:has(> button.${buttonClasses.sizeLarge}) > ${badgeTopRightCircular}`]: {
                        right: spacing[300].px,
                        top: spacing[100].px,
                    },
                },
            },
            badge: {
                fontSize: typography.baseTypography.size[200].rem,
                fontWeight: typography.baseTypography.weight.Medium,
                lineHeight: typography.baseTypography.height.Small,
                height: 'unset',
                padding: `${spacing[200].px} ${spacing[250].px}`,
                [`&.${badgeClasses.anchorOriginTopRightCircular}`]: {
                    top: '10%',
                    right: '10%',
                },
                [`&.${badgeClasses.dot}`]: {
                    padding: 0,
                    minWidth: spacing[200].px,
                    height: spacing[200].px,
                },
                [`&.${badgeClasses.colorPrimary}`]: {
                    backgroundColor: colors.Primary[500],
                },
                [`&.${badgeClasses.colorError}`]: {
                    backgroundColor: colors.Error[500],
                },
                [`&.${badgeClasses.colorInfo}`]: {
                    backgroundColor: colors.Info[500],
                },
                [`&.${badgeClasses.colorSuccess}`]: {
                    backgroundColor: colors.Success[500],
                },
                [`&.${badgeClasses.colorWarning}`]: {
                    backgroundColor: colors.Warning[500],
                },
            },
        },
    },
});
